import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m5.434 12.333 6.533 6.534q.4.399.383.933-.016.533-.416.933a1.4 1.4 0 0 1-.934.384 1.22 1.22 0 0 1-.933-.384l-8.8-8.8a1.2 1.2 0 0 1-.283-.433A1.5 1.5 0 0 1 .9 11q0-.267.084-.5.083-.234.283-.433l8.8-8.8Q10.434.9 10.984.9t.95.367q.4.4.4.95t-.4.95l-6.5 6.5h14.9q.567 0 .95.383t.383.95-.383.95a1.3 1.3 0 0 1-.95.383z"
    }, null, -1)
  ])))
}
export default { render: render }